import { Box, IconButton, Stack, Typography } from '@mui/material';
import AddEducation from '../basic-profile/AddEducation';
import { DeleteSvg, WhiteEditSvgIcon } from 'components/icon/icon';
import { allCapitalize } from 'utils/Utils';

const backIcon = `${process.env.REACT_APP_HOMEPAGE}assets/back-arrow-white.png`;

/**
 * EducationDetailsMobile is a React component that is used to display a form for adding a new education history or editing an existing one in the mobile sidebar.
 * It takes the following props:
 * - educationData: The education data to be edited or the new education data to be added.
 * - id: The id of the education data to be edited.
 * - onCancel: A function that is called when the component should cancel and close.
 * - onEducationDataChange: A function that is called when the user submits the form.
 * - degreeData: The list of all available degree options.
 * - checkingOverlapping: A boolean that indicates if the component should check for overlapping dates.
 * - handleDeleteEducation: A function that is called when the user clicks the delete button.
 * - selectedCard: The education data of the currently selected card.
 * - handleArrowClick: A function that is called when the user clicks the back arrow.
 * - educationLength: The number of education history items.
 * - showEdu: A boolean that indicates if the component should show the education history items.
 * - handleShowEdu: A function that is called when the user clicks the show/hide button.
 * - handleDeleteEdu: A function that is called when the user deletes an education history item.
 * - isReadOnly: A boolean that indicates if the component should be in read-only mode.
 * - setReadOnly: A function that is called when the user clicks the edit button and sets the component to edit mode.
 *
 * The component displays a form with input fields for the education data, a delete button, and a back arrow button.
 * If the user clicks the back arrow button, the component will call the handleArrowClick function.
 * If the user clicks the delete button, the component will call the handleDeleteEducation function.
 * If the user submits the form, the component will call the onEducationDataChange function.
 * If the user clicks the show/hide button, the component will call the handleShowEdu function.
 * If the user clicks the edit button, the component will call the setReadOnly function and set the component to edit mode.
 */
const EducationDetailsMobile = ({ educationData, id, onCancel, onEducationDataChange, degreeData, checkingOverlapping, handleDeleteEducation, selectedCard, handleArrowClick, educationLength, showEdu, handleShowEdu, handleDeleteEdu, isReadOnly, setReadOnly, deleteIncompleteSection }) => {
    return (
        <Box className="sidebar-wrapper">
            <Box className="sidebar-header">
                <Stack direction="row" justifyContent={'flex-start'} alignItems={'flex-start'} spacing={2}>
                    <IconButton aria-label="delete" onClick={() => handleArrowClick()}>
                        <img src={backIcon} alt="Back" width="20px" height="20px" loading="lazy" />
                    </IconButton>
                    <Stack direction="row" justifyContent={'space-between'} alignItems={'flex-start'} sx={{ minWidth: '100%' }}>
                        <Stack spacing={0.5}>
                            <Typography className="title">Add Education</Typography>
                            <Typography className="sub-text" sx={{ width: '85%' }}>
                                {educationData && educationData?.degree_received && educationData?.education_institute_name ? `${educationData?.degree_received} at ${allCapitalize(educationData?.education_institute_name)}`
                                    : 'Add Your higest education degree first'}
                            </Typography>
                        </Stack>
                        {!isReadOnly ?
                            <IconButton className="delete-sec-btn" aria-label="delete" onClick={id ? (event) => { handleDeleteEducation(id, selectedCard?.degree_received, event) } : deleteIncompleteSection}>
                                <DeleteSvg />
                            </IconButton> :
                            <IconButton aria-label="delete" className="edit-icon" disableRipple onClick={() => setReadOnly(false)} sx={{ position: 'absolute', right: '20px' }}>
                                <WhiteEditSvgIcon />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            </Box>
            <Box className="sidebar-content" sx={{ backgroundColor: showEdu && '#FAFAFA!important' }}>
                <AddEducation
                    educationData={educationData}
                    id={id}
                    onCancel={onCancel}
                    onEducationDataChange={onEducationDataChange}
                    degreeData={degreeData}
                    checkingOverlapping={checkingOverlapping}
                    handleArrowClick={handleArrowClick}
                    educationLength={educationLength}
                    showEdu={showEdu}
                    handleShowEdu={handleShowEdu}
                    handleDeleteEdu={handleDeleteEdu}
                    isReadOnly={isReadOnly}
                    setReadOnly={setReadOnly}
                />
            </Box>
        </Box >
    )
}

export default EducationDetailsMobile
